/**
 * Created by JIocb on 13.05.2017.
 */
namespace Factive.Game {
    import DiceData = Factive.Game.DiceData;
    import DiceColorType = Factive.Game.DiceColorType;
    import Rndm = Arkadium.Core.utils.Rndm;

    export class DiceThrower
    {

        private _dicePool:Array<DiceData> = [];
        private _rndm:Rndm;

        public constructor()
        {
            this._rndm = new Rndm();
            this._rndm.initialize(12);
        }

        public throw(numberOfDices:number):Array<DiceData>
        {
            var result:Array<DiceData> = [];
            var numColors:number = Object.keys(DiceColorType).length*.5;
            for(let i = 0; i<numberOfDices; i++)
            {
                var color = Math.ceil(Math.random()*numColors);

                var value = this._rndm.integer(1,7);

                var dice:DiceData = this.fromPool();
                dice.initialize(color,value);

                result[result.length] = dice;
            }
            return result;
        }

        private fromPool():DiceData
        {
            if(this._dicePool.length>0)
            {
                return this._dicePool.shift();
            }

            return new DiceData;
        }

        private toPool(dice:DiceData)
        {
            if(dice === null || dice === undefined)
            {
                return;
            }

            dice.initialize(-1,-1);
            this._dicePool[this._dicePool.length] = dice;
        }
    }
}


// WEBPACK FOOTER //
// src/typescript/Game/Engine/Model/Dice/DiceThrower.ts